import React, { Component, useState, useEffect } from "react";
import {
  StyleSheet,
  TouchableOpacity,
  Switch,
  Image,
  Text,
  Keyboard,
  Vibration,
  View,
  Alert,
} from "react-native";
//import DateTimePicker from "@react-native-community/datetimepicker";
import makeRequest from "../components/makeRequest";

export default function (props) {
  const [mananaApertura, setMananaApertura] = useState(props.mananaApertura);
  const [tardeApertura, setTardeApertura] = useState(props.tardeApertura);
  const [mananaCierre, setMananaCierre] = useState(props.mananaCierre);
  const [tardeCierre, setTardeCierre] = useState(props.tardeCierre);
  const [abreMananas, setAbreMananas] = useState(props.abreMananas);
  const [abreTardes, setAbreTardes] = useState(props.abreTardes);
  useEffect(() => {
    setMananaApertura(props.mananaApertura);
    setTardeApertura(props.tardeApertura);
    setMananaCierre(props.mananaCierre);
    setTardeCierre(props.tardeCierre);
    setAbreMananas(props.abreMananas);
    setAbreTardes(props.abreTardes);
  }, []);
  useEffect(() => {
    const requestUpdate = async () => {
      const response = await makeRequest("horarios/" + props._id, "put", {
        abreMananas: abreMananas,
        abreTardes: abreTardes,
        aperturaManana: mananaApertura,
        aperturaTarde: tardeApertura,
        cierreManana: mananaCierre,
        cierreTarde: tardeCierre,
        diaSemana: props.diaSemana,
        periodo: props.periodo,
      });
    };
    if (props.update) {
      requestUpdate();
    }
  }, [props.update]);
  useEffect(() => {
    const requestCreate = async () => {
      let response = await makeRequest("horarios", "post", {
        abreMananas: abreMananas,
        abreTardes: abreTardes,
        aperturaManana: mananaApertura,
        aperturaTarde: tardeApertura,
        cierreManana: mananaCierre,
        cierreTarde: tardeCierre,
        diaSemana: props.diaSemana,
        periodo: props.periodo,
      });
    };
    if (props.create) requestCreate();
  }, [props.create]);
  return (
    <View style={styles.container}>
      <Text style={styles.title}>{props.dia}</Text>
      <Text style={styles.subtitle}>Mañana</Text>
      <View style={styles.horizontal}>
        <HourSelector initial={mananaApertura} onChange={setMananaApertura} />
        <Text
          style={{
            color: "white",
            fontFamily: "Montserrat-Regular",
            lineHeight: 32,
          }}>
          {" "}
          a{" "}
        </Text>
        <HourSelector initial={mananaCierre} onChange={setMananaCierre} />
      </View>
      <Text style={styles.subtitle}>Tarde</Text>
      <View style={styles.horizontal}>
        <HourSelector initial={tardeApertura} onChange={setTardeApertura} />
        <Text
          style={{
            color: "white",
            fontFamily: "Montserrat-Regular",
            lineHeight: 32,
          }}>
          {" "}
          a{" "}
        </Text>
        <HourSelector initial={tardeCierre} onChange={setTardeCierre} />
      </View>
      <View style={styles.horizontal}>
        <Text style={{ ...styles.subtitle, marginTop: 0 }}>¿Abre mañanas?</Text>
        <Switch value={abreMananas} onValueChange={setAbreMananas} />
      </View>
      <View style={styles.horizontal}>
        <Text style={{ ...styles.subtitle, marginTop: 0 }}>¿Abre tardes?</Text>
        <Switch value={abreTardes} onValueChange={setAbreTardes} />
      </View>
    </View>
  );
}

function HourSelector(props) {
  const [date, setDate] = useState(new Date(props.initial));
  const [mode, setMode] = useState("time");
  const [show, setShow] = useState(false);
  const [hours, setHours] = useState(
    date.getHours() < 10 ? "0" + date.getHours() : date.getHours() + ""
  );
  const [minutes, setMinutes] = useState(
    date.getMinutes() < 10 ? "0" + date.getMinutes() : "" + date.getMinutes()
  );

  const onChange = (event, selectedDate) => {
    const currentDate = selectedDate || date;
    setShow(Platform.OS === "ios");
    setDate(currentDate);
    props.onChange(currentDate.toISOString());
    setMinutes(
      currentDate.getMinutes() < 10
        ? "0" + currentDate.getMinutes()
        : currentDate.getMinutes()
    );
    setHours(
      currentDate.getHours() < 10
        ? "0" + currentDate.getHours()
        : currentDate.getHours()
    );
  };

  const showMode = (currentMode) => {
    setShow(true);
    setMode(currentMode);
  };

  const showTimepicker = () => {
    showMode("time");
  };

  return (
    <>
      <TouchableOpacity style={styles.textInput} onPress={showTimepicker}>
        <Text style={styles.textInput}>
          {hours}:{minutes}
        </Text>
      </TouchableOpacity>
      {show && (
        <DateTimePicker
          testID='dateTimePicker'
          value={date}
          mode={mode}
          is24Hour={true}
          display='default'
          onChange={onChange}
        />
      )}
    </>
  );
}
const styles = StyleSheet.create({
  horizontal: {
    flexDirection: "row",
    justifyContent: "space-around",
    margin: 10,
  },
  textInput: {
    backgroundColor: "white",
    opacity: 0.6,
    maxWidth: 100,
    minWidth: 100,
    borderRadius: 10,
    fontSize: 18,
    lineHeight: 30,

    height: 32,
    fontFamily: "Montserrat-Regular",
    color: "black",
    textAlign: "center",
  },
  subtitle: {
    fontFamily: "Montserrat-Regular",
    fontSize: 15,
    textAlign: "center",
    marginTop: 15,
    color: "white",
  },
  title: {
    fontFamily: "Montserrat-Bold",
    fontSize: 20,
    textAlign: "center",
    marginTop: 15,
    color: "white",
  },
  container: {
    margin: 20,
    color: "white",
    maxWidth: 250,
    width: "90%",
    backgroundColor: "#748a8f",
    alignSelf: "center",
    borderRadius: 25,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
});
